module.exports = __webpack_public_path__ + "img/flower.be7b8a8b.png";